import { Node } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import ContentDrawerGroupComponent from "./ContentDrawerGroupComponent";

export default Node.create({
  name: "content_drawer_group",
  group: "block",
  content: "",
  isolating: true,
  addAttributes() {
    return {
      label: { default: null },
      drawers: { default: [] },
      hasDrawerToggleBtn: { default: true },
      hideContent: { default: false },
    };
  },
  parseHTML() {
    return [{ tag: "div.content-drawer-group" }];
  },
  addNodeView() {
    return ReactNodeViewRenderer(ContentDrawerGroupComponent);
  },
  renderHTML({ node }) {
    return [
      "div",
      {
        class: "content-drawer-group",
        "data-label": node.attrs["label"] || "",
      },
      0,
    ];
  },
});
